import React from "react";
import { Button, ArrowLeftIcon } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const NoPaddingButtonWithStartIcon = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"noPadding button with start icon"}
        value={
          '<Button variant={"noPadding"} startIcon={<ArrowLeftIcon />} color={"info"}>Back</Button>'
        }
      >
        <Button
          variant={"noPadding"}
          startIcon={<ArrowLeftIcon />}
          color={"info"}
        >
          Back
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default NoPaddingButtonWithStartIcon;
